// a React Component that includes the header and footer 

import React, { Component } from "react";

import StaticPageContent from 'common/StaticPageContent';

// use the route name from React Router to request the right data
class StaticPageContainer extends Component {
    render() {
        console.log('this.params', this.props);

        return (
            <div>
                {/*<Header />*/}
                <StaticPageContent pageName={this.props.params.pageName}/>
                {/*<Footer />*/}
            </div>
        )

    }
}

export default StaticPageContainer;